/* eslint-disable react/destructuring-assignment */
import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { parseISO } from 'date-fns'

import DateRangeCalendar from 'components/form/DateRangeCalendar'

// Filter dates arrive as ISO strings (from the URL) or Dates (a selection in
// flight); the calendar wants Dates.
const toDate = (value) => {
  if (!value) return null
  return typeof value === 'string' ? parseISO(value) : value
}

const Wrapper = styled.div`
  padding-bottom: 24px;

  /* Breathe the calendar grid away from the prev/next nav + month
     caption row above it. Matches the host-availability surface. */
  .rdp-month_grid {
    margin-top: 10px;
  }
`

const DatesFilterInputs = ({ onChange, show, ...props }) => {
  const [values, setValues] = useState({
    startDate: toDate(props.startDate),
    endDate: toDate(props.endDate),
  })
  const { startDate, endDate } = values

  const handleDatesChange = (newStart, newEnd) => {
    const newDates = { startDate: newStart, endDate: newEnd }
    setValues(newDates)
    onChange(newDates)
  }

  useEffect(() => {
    setValues({
      startDate: toDate(props.startDate),
      endDate: toDate(props.endDate),
    })
  }, [props.startDate, props.endDate])

  if (!show) return null

  return (
    <Wrapper>
      <DateRangeCalendar
        daySize={40}
        startDate={startDate}
        endDate={endDate}
        onChange={handleDatesChange}
        numberOfMonths={1}
        minDate={new Date()}
      />
    </Wrapper>
  )
}

export default DatesFilterInputs
